import { render, staticRenderFns } from "./entrada_detalhe.vue?vue&type=template&id=073fb9fe&scoped=true"
import script from "./entrada_detalhe.vue?vue&type=script&lang=js"
export * from "./entrada_detalhe.vue?vue&type=script&lang=js"
import style0 from "./entrada_detalhe.vue?vue&type=style&index=0&id=073fb9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fb9fe",
  null
  
)

export default component.exports